import { CWSTR } from 'utils/cwStr';
import { GLOBAL_DATA } from 'src/globalData';

/**
 * Utilities to check LICENCE
 */
export class CWLICENCE {

  /**
   * Check if the module exists
   */
  static hasModule(module: string): boolean {
    try {
      let hasModule = false;
      const modules = GLOBAL_DATA.licences.get("modules");

      if (!CWSTR.isBlank(module)) {
        for (let i = 0, l = modules.length; i < l; i++) {
          if (modules[i] === module) {
            hasModule = true;
          }
        }
      }
      return hasModule;
    } catch (err) {
      return false;
    }
  }
}